<template>
  <div v-if="internalTotalizers && internalTotalizers.length > 0">
    <div style="background: #232328; border-radius: 6px; padding: 2px 8px 2px 8px; display: inline-block; min-width: 110px;">
      <div style="display: flex; justify-content: space-between; font-size: 12px; font-weight: bold; padding-bottom: 2px; border-bottom: 1px solid #333;">
        <span style="color: #43a047;">TAG</span>
        <span style="color: #1976d2;">IN</span>
        <span style="color: #e53935;">OUT</span>
      </div>
      <div v-for="(totalizer, index) in internalTotalizers" :key="index" style="display: flex; justify-content: space-between; font-size: 15px; font-weight: 500; padding-top: 2px;">
        <span style="color: #fff; text-transform: uppercase;">{{ totalizer.tag }}</span>
        <span style="color: #42a5f5;">{{ totalizer.in }}</span>
        <span style="color: #fff;">{{ totalizer.out }}</span>
      </div>
    </div>
  </div>
  <span v-else class="text-muted">-</span>
</template>

<script>
import EventBus from '@/event-bus';
export default {
  name: 'CounterCell',
  props: {
    totalizers: {
      type: Array,
      required: true
    },
    barcode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      internalTotalizers: JSON.parse(JSON.stringify(this.totalizers))
    };
  },
  watch: {
    totalizers(newVal) {
      this.internalTotalizers = JSON.parse(JSON.stringify(newVal));
    }
  },
  mounted() {
    EventBus.$on('parking_counter_updated', this.handleCounterUpdate);
  },
  beforeDestroy() {
    EventBus.$off('parking_counter_updated', this.handleCounterUpdate);
  },
  methods: {
    handleCounterUpdate(data) {
      console.log('[CounterCell] Evento recibido:', data, 'Mi barcode:', this.barcode);
      if (!data || !data.barcode || data.barcode !== this.barcode) return;
      if (Array.isArray(data.totalizers)) {
        this.internalTotalizers = JSON.parse(JSON.stringify(data.totalizers));
      }
    }
  }
}
</script> 